import { toast } from "react-toastify";
import ErrorMessage from "Components/Common/ErrorMessage";

export const showValidationErrors = (err) => {
  if (err?.errors) {
    toast.error(<ErrorMessage messages={err.errors.map((message) => [null, message])} />, {
      position: toast.POSITION.TOP_CENTER,
    });
  }
};
